// extracted by mini-css-extract-plugin
export default {"dropdown":"Menu_dropdown__Q+LKi"};